import { render } from "./HeadingWithIcon.vue?vue&type=template&id=3ae9a309"
import script from "./HeadingWithIcon.vue?vue&type=script&lang=js"
export * from "./HeadingWithIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__